import { create } from 'zustand';

interface ApiState {
  isConnected: boolean;
  apiUrl: string;
  checkConnection: () => Promise<void>;
  callApi: <T>(endpoint: string, options?: RequestInit) => Promise<T>;
}

export const useApiStore = create<ApiState>((set, get) => ({
  isConnected: false,
  apiUrl: import.meta.env.VITE_API_URL || '/api',

  checkConnection: async () => {
    try {
      const response = await fetch(`${get().apiUrl}/health`, {
        method: 'GET',
      });
      set({ isConnected: response.ok });
    } catch (error) {
      console.error('API connection check failed:', error);
      set({ isConnected: false });
    }
  },

  callApi: async <T>(endpoint: string, options?: RequestInit): Promise<T> => {
    const response = await fetch(`${get().apiUrl}${endpoint}`, {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });

    if (!response.ok) {
      throw new Error(`API call failed: ${response.statusText}`);
    }

    return response.json();
  },
}));
